package br.com.htms.inspeccaocampo.data

/**
 * Contagens C / NC / NA e criticidade — mesma regra do Excel consolidado,
 * usada no dashboard web e na aba Dashboard da planilha.
 */
object AgregacaoRespostas {

    data class Counts(val c: Int, val nc: Int, val na: Int, val sem: Int) {
        val respondidas: Int get() = c + nc + na
    }

    fun of(insp: InspecaoCompleta): Counts {
        var c = 0
        var nc = 0
        var na = 0
        var sem = 0
        fun tallyConformidade(code: RespostaConformidade?) {
            when (code) {
                RespostaConformidade.C -> c++
                RespostaConformidade.NC -> nc++
                RespostaConformidade.NA -> na++
                null -> sem++
            }
        }
        fun tallyTernaria(ans: RespostaTernaria?) {
            when (ans) {
                RespostaTernaria.SIM -> c++
                RespostaTernaria.NAO -> nc++
                RespostaTernaria.NA -> na++
                null -> sem++
            }
        }
        when (insp.formTipo) {
            FormTipo.INSPECAO_CAMPO -> insp.form.itens.forEach { tallyTernaria(it.resposta) }
            FormTipo.RELATORIO_FOTO_ALOJAMENTO ->
                insp.relatorioFoto?.itens?.forEach { tallyConformidade(it.resposta) }
            FormTipo.CHECKLIST_ALOJAMENTO,
            FormTipo.CHECKLIST_VETORES ->
                insp.checklistAlojamento?.itens?.forEach { tallyConformidade(it.resposta) }
            FormTipo.CHECKLIST_DIARIO_HTMS,
            FormTipo.CHECKLIST_DIARIO_AXIA ->
                insp.checklistDiario?.itens?.forEach { tallyConformidade(it.resposta) }
            FormTipo.RELATORIO_ALOJAMENTO -> {
                insp.relatorioFoto?.itens?.forEach { tallyConformidade(it.resposta) }
                insp.checklistAlojamento?.itens?.forEach { tallyConformidade(it.resposta) }
            }
            FormTipo.COMUNICACAO_OCORRENCIAS -> Unit
            FormTipo.REM_SEGURANCA_OBRAS,
            FormTipo.RELATORIO_SEGURANCA,
            FormTipo.ACOMPANHAMENTO_AMBIENTAL,
            FormTipo.EVIDENCIA_TREINAMENTO,
            FormTipo.ANALISE_VISUAL_NR -> Unit
        }
        return Counts(c, nc, na, sem)
    }

    fun criticidade(counts: Counts): String {
        if (counts.respondidas == 0) return "N/A"
        return when {
            counts.nc >= 3 || counts.nc.toDouble() / counts.respondidas >= 0.15 -> "ALTA"
            counts.nc >= 1 -> "MEDIA"
            else -> "BAIXA"
        }
    }
}
